<div class="forms-test-container">
  <div class="row border-bottom mb-2 pt-3 align-items-center justify-content-center nav-row">
    <div class="col-auto border-right mb-2 back-col">
      <a (click)="goBack()">
        <p class="mb-0 lh-25 align-middle text-center font-weight pl-3">Back</p>
      </a>
    </div>
    <div class="col border-right mb-2">
      <a (click)="setTab('list')">
        <ng-container *ngIf="currentTab === 'list'">
          <p class="mb-0 lh-25 align-middle text-center font-weight-bold">Form List</p>
        </ng-container>
        <ng-container *ngIf="currentTab !== 'list'">
          <p class="mb-0 lh-25 align-middle text-center font-weight">Form List</p>
        </ng-container>
      </a>
    </div>
    <div class="col mb-2">
      <a (click)="setTab('builder')">
        <ng-container *ngIf="currentTab === 'builder'">
          <p class="mb-0 lh-25 align-middle text-center font-weight-bold">Form Builder</p>
        </ng-container>
        <ng-container *ngIf="currentTab !== 'builder'">
          <p class="mb-0 lh-25 align-middle text-center font-weight">Form Builder</p>
        </ng-container>
      </a>
    </div>
  </div>

  <div class="tab-content pl-1 pr-1">
    <div class="tab-pane" role="tabpanel" [class.active]="currentTab === 'list'" [class.show]="currentTab === 'list'">
      <app-form-list [organizationId]="organizationId" [refreshTrigger]="refreshListTrigger"
        (editFormRequested)="onEditForm($event)"></app-form-list>
    </div>

    <div class="tab-pane" role="tabpanel" [class.active]="currentTab === 'builder'"
      [class.show]="currentTab === 'builder'">
      <app-form-builder *ngIf="currentTab === 'builder' && showBuilder" [organizationId]="organizationId"
        [templateId]="editingTemplateId" (formSaved)="onFormSaved()"
        (formPublished)="onFormPublished()"></app-form-builder>
    </div>
  </div>
</div>